


















































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import TableLayout from '@/components/swine/layout/TableLayout.vue';
import Pagination from '@/components/swine/Pagination.vue';
import {
  RowCountChange,
  PageNumberChange,
} from '@/models/swine/pagination.model';
import { AuditReportListResponse } from '@/models/swine/report/report.model';

@Component({
  components: {
    TableLayout,
    Pagination,
  },
})
export default class MockReportTable extends Vue {
  @Prop({
    type: Array,
    default: null,
  })
  mockReportList!: AuditReportListResponse[];

  @Prop({
    type: Number,
    default: 0,
  })
  totalCount!: number;

  @Prop({
    type: Number,
    default: 1,
  })
  pageNumber!: number;

  @Prop({
    type: Number,
    default: 10,
  })
  rowsPerPage!: number;

  @Prop({
    type: Boolean,
    default: false,
  })
  isSelectionReset!: boolean;

  selectedMockReports: { [key: number]: boolean | null } = {};
  selectedItems: AuditReportListResponse[] = [];
  currentCounter = 0;

  @Watch('isSelectionReset')
  @Emit('reset')
  resetSelection() {
    if (this.isSelectionReset) {
      this.selectedItems.forEach((report) => {
        this.selectedMockReports[report.id] = null;
      });
      this.selectedItems = [];
      this.currentCounter++;
      this.returnSelectedItems();
      return false;
    }
  }

  mounted() {
    this.mockReportList.forEach((details) => {
      this.selectedMockReports[details.id] = false;
    });
  }

  selectItem(selectedProp: AuditReportListResponse, isSelected: boolean) {
    if (isSelected) {
      this.selectedMockReports[selectedProp.id] = isSelected;
      this.selectedItems.push(selectedProp);
    } else {
      this.selectedItems = this.selectedItems.filter((details) => {
        return details.id !== selectedProp.id;
      });
    }
    this.returnSelectedItems();
  }

  @Emit('select')
  returnSelectedItems() {
    return this.selectedItems;
  }

  @Emit('sort')
  sortPressed(field: string, order: 'asc' | 'desc') {
    return `${field}:${order}`;
  }

  @Emit('rowCountChange')
  updateRowCount(params: RowCountChange) {
    return params;
  }

  @Emit('pageNumberChange')
  updatePageNumber(params: PageNumberChange) {
    return params;
  }

  viewAuditReportSummary(id: number) {
    this.$router.push({
      name: `ReportDetails`,
      params: {
        reportId: String(id),
      },
    });
  }
}
